import { z } from "zod";
import { pagedResponse, paginationQuerySchema } from "../common/pagination.js";
import { createProductRequest } from "../products/products.schemas.js";
const candidateStatus = z.enum(["pending", "approved", "rejected", "merged", "ignored"]);
export const variantCandidateInfo = z.object({
    id: z.string().uuid(),
    suggestedProductId: z.string().uuid().nullable(),
    suggestedProductName: z.string().nullable(),
    captureId: z.string().uuid().nullable(),
    cropUri: z.string().nullable(),
    brandNameRaw: z.string().nullable(),
    productNameRaw: z.string().nullable(),
    packSizeRaw: z.string().nullable(),
    score: z.number().nullable(),
    status: candidateStatus,
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const updateVariantCandidateRequest = z.object({
    status: candidateStatus.optional(),
    score: z.number().min(0).max(1).optional(),
}).refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const listVariantCandidatesQuery = paginationQuerySchema.extend({
    status: candidateStatus.optional(),
    suggestedProductId: z.string().uuid().optional(),
    captureId: z.string().uuid().optional(),
    captureSessionId: z.string().uuid().optional(),
    storeId: z.string().uuid().optional(),
});
export const variantCandidatesListResponse = pagedResponse(variantCandidateInfo);
export const approveCandidateRequest = z.object({
    // Exactly one of the two must be provided:
    targetProductId: z.string().uuid().optional(),
    createProduct: createProductRequest.optional(),
    /**
     * When approving to an EXISTING product (targetProductId), also attach the
     * vision-suggested image (metadata.auto_search.image_link) to that product
     * and run it through embedding. Ignored for the create-new path. Default true.
     */
    attachImage: z.boolean().optional().default(true),
}).refine((v) => Boolean(v.targetProductId) !== Boolean(v.createProduct), { message: "Provide exactly one of targetProductId or createProduct" });
export const approveCandidateResponse = z.object({
    candidate: variantCandidateInfo,
    productId: z.string().uuid(),
    productCreated: z.boolean(),
});
export const candidateDecisionItem = z.object({
    candidateId: z.string().uuid(),
    decision: z.enum(["approve", "reject", "ignore"]),
    // Only for decision="approve":
    targetProductId: z.string().uuid().optional(),
    createProduct: createProductRequest.optional(),
    /**
     * When approving to an existing product (targetProductId), also attach the
     * vision-suggested image to that product + embed it. Default true.
     */
    attachImage: z.boolean().optional().default(true),
});
export const batchDecideRequest = z.object({
    items: z.array(candidateDecisionItem).min(1).max(100),
});
export const batchDecideResponse = z.object({
    results: z.array(z.object({
        candidateId: z.string().uuid(),
        status: z.enum(["ok", "error"]),
        productId: z.string().uuid().optional(),
        productCreated: z.boolean().optional(),
        error: z.string().optional(),
    })),
});
//# sourceMappingURL=variant-candidates.schemas.js.map